<template>
  <div>
    <div
      class="modal fade"
      id="modal-check-out-booking-id"
      :ref="`modal-check-out-booking`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentBooking.apartmentInformation") }}
            </h4>
          </div>
          <div
            class="modal-body"
            :style="`overflow-y: auto; height: ${screenHight}px`"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.customerList")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div>
                  <b-table
                    :items="customerInBookingList"
                    :fields="customerInBookingFields"
                    class="mt-3"
                    responsive
                    outlined
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 15px">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.productUsedList")
                      }}</label>
                      <button
                        v-if="
                          parseInt(apartmentInBookingStatus) ===
                            BookingActionEnum.CHECKED_IN
                        "
                        type="button"
                        class="btn btn-primary pull-right"
                        @click="addProductUsed"
                      >
                        <span class="btn-label">
                          <i class="fa fa-plus"></i>
                        </span>
                        {{ $t("common.addnew") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <b-table
                    :items="productUsedList"
                    :fields="productUsedFields"
                    class="mt-3"
                    responsive
                    outlined
                    sticky-header
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template #cell(productPrice)="row">
                      <span>{{ currencyFormat(row.item.productPrice) }}</span>
                    </template>
                    <template #cell(totalFee)="row">
                      <span>{{ currencyFormat(row.item.totalFee) }}</span>
                    </template>
                    <template #cell(actions)="row">
                      <div
                        v-if="
                          parseInt(apartmentInBookingStatus) ===
                            BookingActionEnum.CHECKED_IN
                        "
                        class="btn-group dropleft"
                      >
                        <button
                          type="button"
                          class="btn btn-danger dropdown-toggle btn-sm"
                          data-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i class="fa fa-fw fa-ellipsis-h"></i>
                        </button>
                        <ul class="dropdown-menu" style="min-width: 50px">
                          <li>
                            <button
                              class="btn btn-primary btn-sm"
                              style="margin-left: 6px;"
                              @click="onClickEditProductUsed(row.item)"
                            >
                              <i class="glyphicon glyphicon-edit"></i>
                            </button>
                          </li>
                          <li style="margin-top: 5px">
                            <button
                              style="background-color: #f29911; border-color: #f29911; color:#fff; margin-left: 6px;"
                              class="btn btn-warning btn-sm"
                              @click="onClickUpdateCustomerComplain(row.item)"
                            >
                              <i class="glyphicon glyphicon-trash"></i>
                            </button>
                          </li>
                          <li style="margin-top: 5px">
                            <button
                              class="btn btn-danger btn-sm"
                              style="margin-left: 6px;"
                              @click="onClickDeleteProductUsed(row.item)"
                            >
                              <i class="glyphicon glyphicon-trash"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>

              <div class="col-md-12" style="margin-top: 15px">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartmentBooking.serviceList")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div>
                  <b-table
                    :items="serviceUsedList"
                    :fields="serviceUsedFields"
                    class="mt-3"
                    responsive
                    outlined
                    sticky-header
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template #cell(servicePrice)="row">
                      <span>{{ currencyFormat(row.item.servicePrice) }}</span>
                    </template>
                    <template #cell(totalFee)="row">
                      <span>{{ currencyFormat(row.item.totalFee) }}</span>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 30px">
                <table style="float: right">
                  <tr>
                    <th class="total-currency-title">
                      {{ $t("apartmentBooking.productUsedList") }}
                    </th>
                    <td>{{ currencyFormat(totalFeeProductUsed) }}</td>
                  </tr>
                  <tr>
                    <th class="total-currency-title">
                      {{ $t("apartmentBooking.serviceUsed") }}
                    </th>
                    <td>{{ currencyFormat(totalFeeServiceUsed) }}</td>
                  </tr>
                  <tr>
                    <th class="total-currency-title">
                      {{ $t("apartmentBooking.total") }}
                    </th>
                    <td>{{ currencyFormat(totalFeeProductAndService) }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              v-if="
                parseInt(apartmentInBookingStatus) ===
                  BookingActionEnum.CHECKED_IN
              "
              type="button"
              class="btn btn-primary"
              @click="onShowConfirmCheckOut"
            >
              {{ $t("context_menu.checkout") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal add product used -->
    <div
      class="modal fade"
      :ref="`modal-add-product-used`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onHideModalAddProductUsed"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  productUsedData.id === 0
                    ? "apartmentBooking.addProductUsed"
                    : "apartmentBooking.productUsedDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("product.productList.productName")
                  }}</label>
                  <!-- <input
                    type="text"
                    name=""
                    id=""
                    class="form-control"
                    :placeholder="$t('product.productList.productName')"
                    v-model="productUsedData.productCode"
                  /> -->
                  <v-select
                    class="clear"
                    :options="productInApartmentTypeList"
                    :reduce="data => data"
                    :getOptionLabel="option => option.productName"
                    :placeholder="$t('product.productList.productName')"
                    :filter="onSearchProduct"
                    v-model="productUsedSelect"
                    @option:selected="onSelectProduct"
                    :clearable="false"
                  >
                    <template v-slot:option="option">
                      {{ $t(option.productName) }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div v-if="productUsedSelect">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("product.productList.productCode")
                    }}</label>
                    <span class="form-control product-info" for="">{{
                      productUsedData.productCode
                    }}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("product.productList.productPrice")
                    }}</label>
                    <span class="form-control product-info" for="">{{
                      currencyFormat(productUsedData.productPrice)
                    }}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("serviceAndProductInApartment.quantity")
                    }}</label>
                    <span class="form-control product-info" for="">{{
                      productUsedData.quantity
                    }}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("apartmentBooking.numberOfProductsUsed")
                    }}</label>
                    <input
                      class="form-control"
                      type="number"
                      v-model="productUsedData.numberOfProductsUsed"
                      @input="
                        onChangeNumberOfProductUsed(
                          productUsedData.numberOfProductsUsed
                        )
                      "
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("serviceAndProductInApartment.totalFee")
                    }}</label>
                    <span class="form-control product-info" for="">{{
                      currencyFormat(productUsedData.totalFee)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onHideModalAddProductUsed"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveAddProductUsed"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal delete -->
    <div
      class="modal fade"
      :ref="`modal-delete-and-customer-complain`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onHideModalDeleteProductUsedAndCustomerComplane"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  isDeleteProduct
                    ? "apartmentBooking.deleteProductUsed"
                    : "apartmentBooking.customerComplain"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t(
                      isDeleteProduct
                        ? "apartmentBooking.reasonDelete"
                        : "apartmentBooking.customerComplain"
                    )
                  }}</label>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="6"
                    class="form-control"
                    v-model="reasonDelete"
                  ></textarea>
                  <span v-if="showErrorDelete" style="color: red"
                    ><small>{{
                      $t("common.error_msg[0].required")
                    }}</small></span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onHideModalDeleteProductUsedAndCustomerComplane"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveProductUsedAndCustomerComplane"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal confirm check out -->
    <div
      class="modal fade"
      :ref="`modal-confirm-check-out`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onHideModalConfirmCheckOut"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentBooking.checkOutModal.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                {{ $t('apartmentBooking.checkOutModal.body') }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onHideModalConfirmCheckOut"
            >
              {{ $t("common.delete_modal.btnNo") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onConfirmCheckOut"
            >
              {{ $t("common.delete_modal.btnYes") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import BookingActionEnum from "@/enum/bookingActionEnum";

export default {
  props: {
    bookingId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    apartmentId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    apartmentInBookingStatus: null,
    BookingActionEnum: BookingActionEnum,
    screenHight: 0,
    customerInBookingList: [],
    customerInBookingFields: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center"
      },
      {
        label: "apartmentBooking.customerName",
        key: "customerName",
        class: "text-center"
      },
      {
        label: "user_guest.identification",
        key: "identificationnumber",
        class: "text-center"
      },
      {
        label: "customer.phone",
        key: "customerPhone",
        class: "text-center"
      },
      {
        label: "common.email",
        key: "customerEmail",
        class: "text-center"
      }
      // {
      //   label: "case.status",
      //   key: "status",
      //   class: "text-center"
      // }
    ],
    // product used table
    productUsedFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "productCode",
        label: "product.productList.productCode"
      },
      {
        key: "productName",
        label: "product.productList.productName"
      },
      {
        key: "numberOfProductsUsed",
        label: "apartmentBooking.numberOfProductsUsed",
        class: "text-right"
      },
      // {
      //   key: "productUnit",
      //   label: "product.productUnit"
      // },
      {
        key: "productPrice",
        label: "product.productList.productPrice",
        class: "text-right"
      },
      {
        key: "totalFee",
        label: "serviceAndProductInApartment.totalFee",
        class: "text-right"
      },
      { key: "actions", label: "common.action", class: "text-center" }
    ],
    productUsedList: [],
    // product used data
    productUsedSelect: null,
    productUsedData: {
      id: 0,
      productId: null,
      productCode: null,
      productName: null,
      productPrice: null,
      quantity: null,
      numberOfProductsUsed: 1,
      totalFee: null
    },
    productInApartmentTypeList: [],
    // service list
    serviceUsedFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "serviceCode",
        label: "service.service_code"
      },
      {
        key: "serviceName",
        label: "service.serviceList.serviceName"
      },
      {
        key: "dateTime",
        label: "serviceAndProductInApartment.dateTime"
      },
      {
        key: "servicePackage",
        label: "managementServiceOrder.servicePackage",
        class: "text-right"
      },
      {
        key: "serviceUnit",
        label: "service.serviceUnit",
        class: "text-right"
      },
      {
        key: "totalFee",
        label: "serviceAndProductInApartment.totalFee",
        class: "text-right"
      }
      // { key: "actions", label: "common.action" }
    ],
    serviceUsedList: [],
    totalFeeProductUsed: 0,
    totalFeeServiceUsed: 0,
    totalFeeProductAndService: 0,
    //
    isDeleteProduct: false,
    productUsedDeleteSelect: null,
    reasonDelete: null,
    showErrorDelete: false
  }),
  watch: {
    GET_PRODUCT_IN_APARTMENT_TYPE_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_PRODUCT_IN_APARTMENT_TYPE_LIST_NO_PAGE_DATA;
      this.productInApartmentTypeList = [];
      data.forEach(value => {
        let item = {
          id: value.product.id,
          productCode: value.product.code,
          productName: value.product.name,
          productUnit: value.product.product_unit,
          quantity: value.amount,
          productPrice: value.unit_price,
          totalFee: value.total_price
        };
        this.productInApartmentTypeList.push(item);
      });
    },
    GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING_DATA: function() {
      let data = this.GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING_DATA;
      this.apartmentInBookingStatus = data.booking_status;
      this.productUsedList = [];
      this.totalFeeProductAndService = 0;
      let productUsed = data.product_used;
      this.totalFeeProductUsed = 0;
      productUsed.forEach((product, index) => {
        let productItem = {
          id: product.id,
          nonumber: index + 1,
          productId: product.product_info.id,
          productCode: product.product_info.name,
          productName: product.product_info.code,
          numberOfProductsUsed: product.number_of_product_used,
          productPrice: product.unit_price,
          totalFee: product.total_fee,
          customerComplain: product.customer_complain,
          reasonDeleted: product.reason_deleted
        };
        if (!utils.isEmptyString(product.total_fee)) {
          this.totalFeeProductUsed += parseInt(product.total_fee);
        }
        this.productUsedList.push(productItem);
      });
      // service used
      let serviceUsed = data.service_order;
      this.serviceUsedList = [];
      this.totalFeeServiceUsed = 0;
      serviceUsed.forEach((service, index) => {
        let serviceItem = {
          id: service.id,
          nonumber: index + 1,
          serviceCode: service.service_data.code,
          serviceName: service.service_data.name,
          serviceUnit: service.service_package.mass_corresponding,
          servicePackage: service.service_package.package_name,
          totalFee: service.total_fee,
          dateTime: utils.formatSqlDate(service.date_of_use, null, "DD/MM/YYYY")
        };
        if (!utils.isEmptyString(service.total_fee)) {
          this.totalFeeServiceUsed += parseInt(service.total_fee);
        }
        this.serviceUsedList.push(serviceItem);
      });
      this.totalFeeProductAndService =
        this.totalFeeProductUsed + this.totalFeeServiceUsed;
      // customer in apartment
      let customerInApartment = data.user_in_booking;
      this.customerInBookingList = [];
      customerInApartment.forEach((customer, index) => {
        let customerItem = {
          id: customer.id,
          nonumber: index + 1,
          customerName: customer.full_name,
          customerPhone: customer.phone,
          customerEmail: customer.email,
          customerGender: customer.gender,
          identificationnumber: customer.identificationnumber,
          customerDob: utils.formatSqlDate(customer.dob, null, "DD-MM-YYYY")
        };
        this.customerInBookingList.push(customerItem);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_PRODUCT_IN_APARTMENT_TYPE_LIST_NO_PAGE_DATA",
      "GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING_DATA"
    ])
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.screenHight =
        window.innerHeight - 187 > 300 ? window.innerHeight - 187 : 300;
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onShowConfirmCheckOut: function() {
      this.onShowModalConfirmCheckOut()
    },
    onShowModal: function() {
      $(this.$refs[`modal-check-out-booking`]).modal("show");
      this.getProductAndServiceInApartmentInBooking();
    },
    onCloseModal: function() {
      $(this.$refs[`modal-check-out-booking`]).modal("hide");
    },
    /*
     ** add product used
     */
    onSearchProduct: function(options, search) {
      let resultSearch = options.filter(
        x =>
          utils
            .replaceCharactersVNLanguage(x.productName.toLowerCase())
            .includes(
              utils.replaceCharactersVNLanguage(search.toLowerCase())
            ) ||
          utils
            .replaceCharactersVNLanguage(x.productCode.toLowerCase())
            .includes(utils.replaceCharactersVNLanguage(search.toLowerCase()))
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    onSelectProduct: function(data) {
      this.productUsedData.productId = data.id;
      this.productUsedData.productCode = data.productCode;
      this.productUsedData.productName = data.productName;
      this.productUsedData.productPrice = data.productPrice;
      this.productUsedData.quantity = data.quantity;
      this.productUsedData.totalFee =
        data.productPrice * this.productUsedData.numberOfProductsUsed;
    },
    onShowModalAddProductUsed: function() {
      $(this.$refs[`modal-add-product-used`]).modal("show");
    },
    onHideModalAddProductUsed: function() {
      $(this.$refs[`modal-add-product-used`]).modal("hide");
    },
    onChangeNumberOfProductUsed: function(data) {
      if (utils.isEmptyString(data) || data <= 0 || data > this.productUsedData.quantity) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else {
        this.productUsedData.totalFee =
          this.productUsedData.productPrice *
          this.productUsedData.numberOfProductsUsed;
      }
    },
    onClickEditProductUsed: function(data) {
      this.productUsedData.id = data.id;
      let index = this.productInApartmentTypeList.findIndex(
        x => x.id === data.productId
      );
      if (index !== -1) {
        this.productUsedSelect = this.productInApartmentTypeList[index];
        this.productUsedData.numberOfProductsUsed = data.numberOfProductsUsed;
        this.onSelectProduct(this.productInApartmentTypeList[index]);
      }
      this.onShowModalAddProductUsed();
    },
    addProductUsed: function() {
      this.productUsedSelect = null;
      this.onShowModalAddProductUsed();
    },
    onSaveAddProductUsed: function() {
      if (utils.isEmptyString(this.productUsedData.productId)) {
        this.showError(this.$t("product.productList.productName"));
      } else if (
        utils.isEmptyString(this.productUsedData.numberOfProductsUsed) ||
        this.productUsedData.numberOfProductsUsed <= 0
      ) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else if (this.productUsedData.numberOfProductsUsed > this.productUsedData.quantity) {
        this.showError(this.$t("serviceAndProductInApartment.quantity1"));
      } else {
        let data = {
          id: this.productUsedData.id,
          productId: this.productUsedData.productId,
          productName: this.productUsedData.productName,
          productCode: this.productUsedData.productCode,
          productPrice: this.productUsedData.productPrice,
          numberOfProductsUsed: this.productUsedData.numberOfProductsUsed,
          totalFee: this.productUsedData.totalFee,
          apartmentId: this.apartmentId,
          bookingId: this.bookingId
        };
        if (this.productUsedData.id === 0) {
          this.ADD_PRODUCT_USED_IN_APARTMENT_BOOKING(data)
            .then(
              function() {
                this.onHideModalAddProductUsed();
                this.getProductAndServiceInApartmentInBooking();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                let mess = error.response.data.message;
                this.showError(mess);
              }.bind(this)
            );
        } else {
          this.UPDATE_PRODUCT_USED_IN_APARTMENT_BOOKING(data)
            .then(
              function() {
                this.onHideModalAddProductUsed();
                this.getProductAndServiceInApartmentInBooking();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                let mess = error.response.data.message;
                this.showError(mess);
              }.bind(this)
            );
        }
      }
    },
    getProductAndServiceInApartmentInBooking: function() {
      let filter = {
        params: {
          apartmentId: this.apartmentId,
          bookingId: this.bookingId
        }
      };
      this.GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING(filter);
    },
    /*
     * delete product used and customer complain
     */
    onShowModalDeleteProductUsedAndCustomerComplane: function() {
      $(this.$refs[`modal-delete-and-customer-complain`]).modal("show");
    },
    onHideModalDeleteProductUsedAndCustomerComplane: function() {
      $(this.$refs[`modal-delete-and-customer-complain`]).modal("hide");
    },
    onClickDeleteProductUsed: function(data) {
      this.isDeleteProduct = true;
      this.productUsedDeleteSelect = data;
      this.reasonDelete = data.reasonDeleted;
      this.onShowModalDeleteProductUsedAndCustomerComplane();
    },
    onClickUpdateCustomerComplain: function(data) {
      this.isDeleteProduct = false;
      this.productUsedDeleteSelect = data;
      this.reasonDelete = data.customerComplain;
      this.onShowModalDeleteProductUsedAndCustomerComplane();
    },
    onSaveProductUsedAndCustomerComplane: function() {
      if (utils.isEmptyString(this.reasonDelete)) {
        this.showErrorDelete = true;
      } else {
        this.showErrorDelete = false;
        let data = {
          id: this.productUsedDeleteSelect && this.productUsedDeleteSelect.id,
          reason: this.reasonDelete,
          isDeleteProduct: this.isDeleteProduct
        };
        this.UPDATE_DELETE_PRODUCT_USED_OR_CUSTOMER_COMPLAIN(data)
          .then(
            function() {
              this.onHideModalDeleteProductUsedAndCustomerComplane();
              this.getProductAndServiceInApartmentInBooking();
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              let mess = error.response.data.message;
              this.showError(mess);
            }.bind(this)
          );
      }
    },
    // confirm check out
    onShowModalConfirmCheckOut: function() {
      $(this.$refs[`modal-confirm-check-out`]).modal("show");
    },
    onHideModalConfirmCheckOut: function() {
      $(this.$refs[`modal-confirm-check-out`]).modal("hide");
    },
    onConfirmCheckOut: function() {
      let data = {
        apartmentId: this.apartmentId,
        bookingId: this.bookingId
      };
      this.CHECK_OUT_APARTMENT_IN_BOOKING(data)
        .then(
          function(res) {
            let data = res.data;
            this.onHideModalConfirmCheckOut();
            this.onCloseModal()
            this.$emit('callBackDataCheckOut', data.status)
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ADD_PRODUCT_USED_IN_APARTMENT_BOOKING",
      "UPDATE_PRODUCT_USED_IN_APARTMENT_BOOKING",
      "GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING",
      "UPDATE_DELETE_PRODUCT_USED_OR_CUSTOMER_COMPLAIN",
      "CHECK_OUT_APARTMENT_IN_BOOKING"
    ])
  }
};
</script>
<style scoped>
.product-info {
  background: #e4e7e8;
}
.total-currency-title {
  padding: 0 10px 0 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentBooking/CheckOutModal.vue